import { z } from "zod";

import { OauthFlowType } from "@/constants/oauth-flow-type";

export const oauthFormSchema = z
	.object({
		flowType: z.enum([OauthFlowType.PasswordGrant, OauthFlowType.ClientCredentialsGrant]),
		clientId: z.string().optional(),
		clientSecret: z.string().optional(),
		username: z.string().nullish(),
		password: z.string().nullish(),
		tokenUrl: z.string().optional(),
		scope: z.string().nullish(),
	})
	.superRefine((data, ctx) => {
		if (data.flowType === OauthFlowType.PasswordGrant) {
			if (!data.username || data.username.trim() === "") {
				ctx.addIssue({
					code: "custom",
					message: "Username is required",
					path: ["username"],
				});
			}

			if (!data.password || data.password.trim() === "") {
				ctx.addIssue({
					code: "custom",
					message: "Password is required",
					path: ["password"],
				});
			}

			// Both clientId and clientSecret must be provided together, or both must be empty
			const hasClientId = !!data.clientId;
			const hasClientSecret = !!data.clientSecret;

			// XOR logic: if one is provided but not the other, error
			if (hasClientId !== hasClientSecret) {
				if (!hasClientId) {
					ctx.addIssue({
						code: "custom",
						message: "Required",
						path: ["clientId"],
					});
				}
				if (!hasClientSecret) {
					ctx.addIssue({
						code: "custom",
						message: "Required",
						path: ["clientSecret"],
					});
				}
			}
		} else if (data.flowType === OauthFlowType.ClientCredentialsGrant) {
			if (!data.clientId || data.clientId.trim() === "") {
				ctx.addIssue({
					code: "custom",
					message: "Client ID is required",
					path: ["clientId"],
				});
			}

			if (!data.clientSecret || data.clientSecret.trim() === "") {
				ctx.addIssue({
					code: "custom",
					message: "Client Secret is required",
					path: ["clientSecret"],
				});
			}
		}

		if (!data.tokenUrl || data.tokenUrl.trim() === "") {
			ctx.addIssue({
				code: "custom",
				message: "Token URL is required",
				path: ["tokenUrl"],
			});
		} else if (!/^http[s]?:\/\/.+/i.test(data.tokenUrl)) {
			ctx.addIssue({
				code: "custom",
				message: "Token URL must start with http:// or https://",
				path: ["tokenUrl"],
			});
		}
	});

export type OauthForm = z.infer<typeof oauthFormSchema>;
